import React, { useEffect, useRef, useState } from 'react';

import { BsX } from "react-icons/bs";
import './ShareBox.css';
import { QRCodeSVG } from 'qrcode.react';
import { ErrorBoundary } from 'react-error-boundary';
import { useAtom } from 'jotai';
import { shareInfoAtom } from '../../atoms';
import { useSearchParams } from 'react-router-dom';

const ShareBox: React.FC = () => {

    const [url, setUrl] = useState<string>('');
    const [shareInfo, setShareInfo] = useAtom(shareInfoAtom);
    const searchParams = useSearchParams()[0];
    const [tooltipVisible, setTooltipVisible] = useState<boolean>(false);
    
    const qrCodeRef = useRef<SVGSVGElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);


    const handleDownload = () => {
        if (qrCodeRef.current && canvasRef.current) {
          const svg = qrCodeRef.current;
          const canvas = canvasRef.current;
          const ctx = canvas.getContext('2d');
          const padding = 16; // パディングのサイズ
    
          if (ctx) {
            const svgData = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
            const url = URL.createObjectURL(svgBlob);
    
            img.onload = () => {
              const qrSize = 256;
              const canvasSize = qrSize + padding * 2;
              canvas.width = canvasSize;
              canvas.height = canvasSize;
    
              ctx.fillStyle = '#ffffff'; // 背景色を設定
              ctx.fillRect(0, 0, canvas.width, canvas.height); // 背景を塗りつぶす
    
              ctx.drawImage(img, padding, padding, qrSize, qrSize);
              URL.revokeObjectURL(url);
    
              const pngUrl = canvas.toDataURL('image/png');
              const downloadLink = document.createElement('a');
              downloadLink.href = pngUrl;
              downloadLink.download = 'qrcode.png';
              downloadLink.click();
            };
    
            img.src = url;
          }
        }
      };


    /* ****************
     * URLをコピー
     * ****************/ 
    useEffect(() => {
        if(!shareInfo) { return; }
        setUrl(`${window.location.href}&marker=on`);
    }, [shareInfo, searchParams]);


    /* ****************
     * URLをコピー
     * ****************/ 
    const copyUrl = () => {
        navigator.clipboard.writeText(url).then(
            () => { 
                setTooltipVisible(true);
                setTimeout(() => { setTooltipVisible(false); }, 2000);
             },
            () => { console.error('Failed to copy URL'); },
        );
    };

    if(!shareInfo) { return <></>; }

    return (
        <div className="dialog-overlay" onClick={() => setShareInfo(undefined)}>
        <div className="share-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="share-dialog-header">
                <h2>共有</h2>
                <BsX onClick={() => setShareInfo(undefined)} />
            </div>
            <div className="share-dialog-content">
                <div className='qrcode-container'>
                    <div className='qrcode'>
                        { url.length > 150 ? 
                            <p className='qrcode-img'>選択データが多くQRコードを生成できませんでした。</p> 
                            :
                            <ErrorBoundary fallback={<p>QRコードの生成に失敗しました</p>}>
                                <a className='qrcode-img' href="#" onClick={handleDownload}>
                                    <QRCodeSVG
                                        value={url}
                                        size={86}
                                        bgColor={"#ffffff"}
                                        fgColor={"#0179C4"}
                                        ref={qrCodeRef}
                                    />
                                </a>
                                <canvas ref={canvasRef} width="256" height="256" style={{ display: 'none' }}></canvas>
                            </ErrorBoundary>
                        }
                    </div>
                    <div className='detail'>
                        {shareInfo.id && <p className='detail-title'>{shareInfo.id}</p>}
                        <div className='lngLat detail-content'>
                            <div className='item'>
                                <p className='item-title'>緯度</p>
                                <p>{shareInfo.lngLat.lat}</p>
                            </div>
                            <div className='item'>
                                <p className='item-title'>経度</p>
                                <p>{shareInfo.lngLat.lng}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='url-copy-container'>
                    <label className='url-box'>
                        <span>共有リンク</span>
                        <input type="text" value={url} readOnly />
                    </label>
                    <button onClick={copyUrl}>リンクをコピー</button>
                    {tooltipVisible && <div className='tooltip'>コピーしました</div>}
                </div>
            </div>
        </div>
    </div>
    );
};

export default ShareBox;
